import axios from 'axios';

// 記事全件取得
export function getMiiitsArticle(repository) {
    return new Promise(resolve => {
        const payload = axios
            .get(`/api-miiits/${repository}/`, {
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(response => {
                return { payload: response };
            })
            .catch(error => {
                return { error };
            });
        resolve(payload);
    });
}

// カテゴリ全件取得
export function getArticleCategory(repository) {
    return new Promise(resolve => {
        const payload = axios
            .get(`/api-miiits/${repository}/`, {
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(response => {
                return { payload: response };
            })
            .catch(error => {
                return { error };
            });
        resolve(payload);
    });
}